import styles from './MapLegend.module.scss';
import {
  areaMarkerUrl,
  dpeMarkerUrl,
  dpeCombinedMarkerUrl,
} from '../../../../../constant';

interface LegendItem {
  id: string;
  iconSrc: string;
  altText: string;
  label: string;
}

function MapLegend() {
  const legendItems: LegendItem[] = [
    {
      id: 'dpe',
      iconSrc: dpeMarkerUrl,
      altText: 'Marqueur DPE',
      label: 'DPE',
    },
    {
      id: 'parcelle',
      iconSrc: areaMarkerUrl,
      altText: 'Marqueur Parcelle',
      label: 'Parcelle',
    },
    {
      id: 'dpe-parcelle',
      iconSrc: dpeCombinedMarkerUrl,
      altText: 'Marqueur DPE + Parcelle',
      label: 'DPE + Parcelle',
    },
  ];

  return (
    <div className={styles.mapLegend}>
      <h4 className={styles.title}>Légende</h4>
      <div className={styles.legendItems}>
        {legendItems.map((item) => (
          <div key={item.id} className={styles.legendItem}>
            <img
              src={item.iconSrc}
              alt={item.altText}
              className={styles.markerIcon}
            />
            <span className={styles.label}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MapLegend;
